exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block {\n  display: inline-block; }\n\ndiv.inline-edit {\n  text-decoration: none;\n  border-bottom: #A8B9CE dashed 0px;\n  cursor: pointer;\n  text-align: left;\n  padding-bottom: 0px;\n  width: auto;\n  font-size: 11px; }\n\ndiv.inline-edit span {\n    padding: 1px 0 2px 0; }\n\ndiv.inline-edit i {\n    display: none; }\n\ndiv.inline-edit:hover i {\n    display: inline; }\n\ninput {\n  border-bottom: #ccc dashed 1px;\n  border-radius: 2px;\n  padding: 0px 3px 3px 0;\n  outline: none;\n  background: transparent;\n  width: 100px;\n  text-align: center;\n  font-size: 11px;\n  font-style: italic;\n  color: #969494 !important; }\n\ninput:focus {\n  outline: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/inline-edit/inline-edit.component.scss
// module id = ../../../../../src/app/shared/components/inline-edit/inline-edit.component.scss
// module chunks = main